import {
  http,
} from "./http";

async function getCustomsManagerSelect(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function fetchAllCustomsManagers(resource) {
  const response = await http.get(`${resource}/customs-managers`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function searchCustomManager(resource, search) {
  const response = await http.get(
    `${resource}/customs-managers?searchTerm=${search}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

async function getLogistSelect(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    title: response.data.Title,
    id: response.data.Id,
  };
}

async function fetchAllLogists(resource) {
  const response = await http.get(`${resource}/logists`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function searchLogist(resource, search) {
  const response = await http.get(`${resource}/logists?searchTerm=${search}`);
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response;
  }
}

async function getShippings(id) {
  const response = await http.get("shippings/available-for-route", {
    params: {
      countryId: id,
    },
  });
  return response.data.length > 0 ? response.data.map(i => {
    return {
      id: i.Id,
      phaseId: i.PhaseId,
      number: i.Number,
      date: i.Date,
      manager: i.Manager ? {
        id: i.Manager.Id,
        title: i.Manager.Title,
      } : null,
      client: i.Client ? {
        id: i.Client.Id,
        title: i.Client.Title,
      } : null,
      factory: i.SenderFactory ? {
        id: i.SenderFactory.Id,
        title: i.SenderFactory.Title,
      } : null,
      manufacturers: i.Manufacturers,
      country: i.Country ? {
        id: i.Country.Id,
        title: i.Country.Title,
      } : null,
      unloadingCity: i.UnloadingCity ? {
        id: i.UnloadingCity.Id,
        title: i.UnloadingCity.Title,
      } : null,
    };
  }) : [];
}

async function getRoute(id) {
  const response = await http.get(`routes/${id}`);
  return {
    arriveToUnloadingPlaceDate: response.data.ArriveToUnloadingPlaceDate,
    arriveToWarehouseDateFact: response.data.ArriveToWarehouseDateFact,
    arriveToWarehouseDatePlan: response.data.ArriveToWarehouseDatePlan,
    cargoPlaces: response.data.CargoPlaces,
    carrier: response.data.Carrier ? { id: response.data.Carrier.Id, title: response.data.Carrier.Title } : null,
    customsManager: response.data.CustomsManager ?
      { id: response.data.CustomsManager.Id, title: response.data.CustomsManager.Title } :
      null,
    customsRegistrationDateFact: response.data.CustomsRegistrationDateFact,
    customsRegistrationDatePlan: response.data.CustomsRegistrationDatePlan,
    date: response.data.Date,
    direction: response.data.Direction ? { id: response.data.Direction.Id, title: response.data.Direction.Title } : null,
    driver: response.data.Driver ? {
      carrier: response.data.Driver.Carrier ? { id: response.data.Driver.Carrier.Id, title: response.data.Driver.Carrier.Title } : null,
      id: response.data.Driver.Id,
      isRemoved: response.data.Driver.IsRemoved,
      name: response.data.Driver.Name,
      phones: response.data.Driver.Phones,
      surname: response.data.Driver.Surname,
      title: response.data.Driver.Title,
      viber: response.data.Driver.Viber,
    } : null,
    forwarder: response.data.Forwarder ? { id: response.data.Forwarder.Id, title: response.data.Forwarder.Title } : null,
    id: response.data.Id,
    loadingLastDate: response.data.LoadingLastDate,
    loadingStartDate: response.data.LoadingStartDate,
    logist: response.data.Logist ? { id: response.data.Logist.Id, title: response.data.Logist.Title } : null,
    number: response.data.Number,
    passingBorderDateFact: response.data.PassingBorderDateFact,
    passingBorderDatePlan: response.data.PassingBorderDatePlan,
    routePrefix: response.data.RoutePrefix,
    state: response.data.State ? { id: response.data.State.Id, title: response.data.State.Title } : null,
    unloadingPlaces: response.data.UnloadingPlaces.length > 0 ? response.data.UnloadingPlaces.map(i => {
      return {
        id: i.Id,
        unloadingCountry: i.UnloadingCountry ? {
          id: i.UnloadingCountry.Id,
          title: i.UnloadingCountry.Title,
        } : null,
        unloadingWarehouse: i.UnloadingWarehouse ? {
          id: i.UnloadingWarehouse.Id,
          title: i.UnloadingWarehouse.Title,
          groupedWarehouse: i.UnloadingWarehouse.GroupedWarehouse,
        } : null,
        unloadingFactory: i.UnloadingFactory ? {
          id: i.UnloadingFactory.Id,
          title: i.UnloadingFactory.Title,
        } : null,
        unloadingAddress: i.UnloadingAddress ? {
          id: i.UnloadingAddress.Id,
          title: i.UnloadingAddress.Title,
        } : null,
      };
    }) : [],
    vehicle: response.data.Vehicle ? {
      carryingCapacity: response.data.Vehicle.CarryingCapacity,
      id: response.data.Vehicle.Id,
      isRemoved: response.data.Vehicle.IsRemoved,
      title: response.data.Vehicle.Title,
      volume: response.data.Vehicle.Volume,
    } : null,
    volume: response.data.Volume,
    weightBrutto: response.data.WeightBrutto,
    weightNetto: response.data.WeightNetto,
    attachments: response.data.Attachments.length > 0 ? response.data.Attachments.map(a => {
      return {
        id: a.Id,
        title: a.Title,
      };
    }) : [],
  };
}

async function getRouteItems(id) {
  const response = await http.get(`routes/${id}/route-items`);
  return {
    transportInfo: {
      cargoPlaces: response.data.CargoPlaces,
      cargoPlacesInCar: response.data.CargoPlacesInCar,
      overallVolumeInCar: response.data.OverallVolumeInCar,
      volume: response.data.Volume,
      weightInCar: response.data.WeightInCar,
      weightPlan: response.data.WeightPlan,
    },
    routeDates: {
      startOfRouteFact: response.data.StartOfRouteFact,
      startOfRoutePlan: response.data.StartOfRoutePlan,
    },
    items: response.data.Items.map(i => {
      return {
        id: i.Id,
        shippingId: i.Shipping.Id,
        deliveryToUnloadingPlaceFact: i.DeliveryToUnloadingPlaceDates ? i.DeliveryToUnloadingPlaceDates.Fact : null,
        deliveryToUnloadingPlacePlan: i.DeliveryToUnloadingPlaceDates ? i.DeliveryToUnloadingPlaceDates.Plan : null,
        inCar: i.InCar,
        readyForShipmentFact: i.ReadyForShipmentFact,
        route: i.Route ? { id: i.Route.Id, title: i.Route.Title } : null,
        shippingSenderAddress: i.Shipping.SenderAddress ? { id: i.Shipping.SenderAddress.Id, title: i.Shipping.SenderAddress.Title } : null,
        shippingSenderFactory: i.Shipping.SenderFactory ? { id: i.Shipping.SenderFactory.Id, title: i.Shipping.SenderFactory.Title } : null,
        shippingSenderWarehouse: i.Shipping.SenderWarehouse ?
          { id: i.Shipping.SenderWarehouse.Id, title: i.Shipping.SenderWarehouse.Title } :
          null,
        senderAddress: i.SenderAddress ? {
          country: i.SenderAddress.Country ? { id: i.SenderAddress.Country.Id, title: i.SenderAddress.Country.Title } : null,
          id: i.SenderAddress.Id,
          isRemoved: i.SenderAddress.IsRemoved,
          postcode: i.SenderAddress.Postcode,
          title: i.SenderAddress.Title,
        } : null,
        senderFactory: i.SenderFactory ? { id: i.SenderFactory.Id, title: i.SenderFactory.Title } : null,
        senderWarehouse: i.SenderWarehouse ? { id: i.SenderWarehouse.Id, title: i.SenderWarehouse.Title } : null,
        loadingAddress: i.LoadingAddress ? {
          country: i.LoadingAddress.Country ? { id: i.LoadingAddress.Country.Id, title: i.LoadingAddress.Country.Title } : null,
          id: i.LoadingAddress.Id,
          isRemoved: i.LoadingAddress.IsRemoved,
          postcode: i.LoadingAddress.Postcode,
          title: i.LoadingAddress.Title,
        } : null,
        postcode: i.Shipping.LoadingAddress ? i.Shipping.LoadingAddress.Postcode : "",
        number: i.Shipping.Number,
        loadingNumber: i.Shipping.LoadingNumber,
        shippingType: i.Shipping.ShippingType,
        phaseType: i.PhaseType ? { id: i.PhaseType.Id, title: i.PhaseType.Title } : null,
        volume: { shippingInfo: i.Shipping.Volume, routeItem: i.Volume },
        weight: { shippingInfo: i.Shipping.Weight, routeItem: i.Weight },
        cargoPlaces: { shippingInfo: i.Shipping.CargoPlaces, routeItem: i.CargoPlaces },
        readyDate: i.Shipping.ReadyDate,
        clientAlias: i.Shipping.ClientAlias,
        aliases: i.Shipping.Aliases,
        productDescription: i.Shipping.ProductDescription,
        phaseId: i.PhaseId,
        totalDataFromGoodDetails: i.TotalDataFromGoodDetails,
        odrer: i.Order,
        unloaded: i.Unloaded,
        arrivalAddress: { id: i.ArrivalAddress.Id, title: i.ArrivalAddress.Title },
        unloadingPlaceId: i.UnloadingPlaceId,
        unloadingDate: i.UnloadingDate,
        hasImages: i.HasImages,
        hasUnreadNotes: i.HasUnreadNotes,
        hasUndonePreviousPhase: i.HasUndonePreviousPhase,
        shippingIsFirstInRoutePhase: i.Shipping.IsFirstInRoutePhase,
        factoryClosingDate: i.Shipping.FactoryClosingDate,
        attachments: i.Shipping.Attachments.map(a => {
          return {
            id: a.Id,
            title: a.Title,
          };
        }),
        attachmentsForExport: i.Shipping.AttachmentsForExport.map(a => {
          return {
            id: a.Id,
            title: a.Title,
          };
        }),
        shippingState: i.Shipping.ShippingState,
        hasAwaitingPreviousPhase: i.HasAwaitingPreviousPhase,
        loadingLogist: i.LoadingLogist,
        allowEditing: i.AllowEditing,
        phaseState: i.PhaseState ? { id: i.PhaseState.Id, title: i.PhaseState.Title } : null,
        cargoComment: i.CargoComment,
      };
    }),
  };
}

async function changeFactoryClosingDate(id, itemId, date) {
  const response = await http.patch(`/routes/${id}/route-items/${itemId}/factory-closing-date`, {
    value: date,
  });
  return response;
}

async function changeState(id, newVal) {
  const response = await http.patch(`/routes/${id}/states`, {
    value: newVal,
  });
  return response;
}

async function deleteRoute(id) {
  await http.delete(`routes/${id}`);
  return true;
}

async function saveCustomsRegistrationDate(id, date) {
  const response = await http.patch(
    `routes/${id}/customs-registration-date-plan`,
    date,
  );
  return response;
}

async function saveArriveToWarehouseDate(id, date) {
  const response = await http.patch(
    `routes/${id}/arrive-to-warehouse-date-plan`,
    date,
  );
  return response;
}

async function changeRouteInfo(id, name, val) {
  const response = await http.patch(`routes/${id}/${name}`, {
    value: val,
  });
  return response;
}

async function saveRoutePrefix(id, prefix) {
  const response = await http.patch(`routes/${id}/prefix`, {
    value: prefix,
  });
  return response;
}

async function saveReadyForShipmentDate(routeId, itemId, plan) {
  const response = await http.patch(
    `routes/${routeId}/items/${itemId}/ready-for-shipment-date`, {
      value: plan,
    },
  );
  return response;
}

async function getFactoryLoadingPlace(id) {
  const response = await http.get(`factories/${id}/loading-places`);
  return response.data.map(item => {
    return {
      id: item.Id,
      address: item.Address ? {
        buildNumber: item.Address.BuildNumber,
        city: item.Address.City ? {
          id: item.Address.City.Id,
          title: item.Address.City.Title,
        } : null,
        country: item.Address.Country ? {
          id: item.Address.Country.Id,
          title: item.Address.Country.Title,
          inputLanguage: item.Address.Country.InputLanguage,
        } : null,
        district: item.Address.District ? {
          id: item.Address.District.Id,
          title: item.Address.District.Title,
        } : null,
        id: item.Address.Id,
        isConfirmed: item.Address.IsConfirmed,
        isRemoved: item.Address.IsRemoved,
        postcode: item.Address.Postcode,
        region: item.Address.Region ? {
          id: item.Address.Region.Id,
          title: item.Address.Region.Title,
        } : null,
        street: item.Address.Street,
        title: item.Address.Title,
      } : null,
      contactPersons: item.ContactPersons.length ? item.ContactPersons.map(i => {
        return {
          id: i.Id,
          name: i.Name,
          surname: i.Surname,
          fullName: i.FullName,
          phones: i.Phones,
          emails: i.Emails,
          skypes: i.Skypes,
          position: i.Position ? {
            id: i.Position.Id,
            title: i.Position.Title,
          } : null,
          role: i.Role ? {
            id: i.Role.Id,
            title: i.Role.Title,
          } : null,
          isConfirmed: i.IsConfirmed,
          isRemoved: i.IsRemoved,
        };
      }) : [],
    };
  });
}

async function updateLoadingAddress(
    factoryId,
    shippingId,
    shippingPhaseId,
    addressId,
) {
  const response = await http.patch("routes/loading-address", {
    factoryId,
    shippingId,
    shippingPhaseId,
    addressId,
  });
  return response;
}

async function getFactoryLoadingPlaceReference(factoryId, id) {
  const response = await http.get(
    `factories/${factoryId}/loading-places/referencies/${id}`,
  );
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function getLoadingPlaceReference(id) {
  const response = await http.get(`factories/${id}/loading-places`);
  return response.data.map(i => {
    return {
      text: i.Address.Title,
      value: i.Address.Id,
      countryId: i.Address.Country.Id,
    };
  });
}

async function searchLoadingPlace(factoryId, search) {
  const response = await http.get(
    `factories/${factoryId}/loading-places?searchTerm=${search}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Address.Title,
        value: i.Address.Id,
      };
    });
  } else {
    response.data = [];
    return response.data;
  }
}

async function createUnloadingPlace(id, unloadingPlace) {
  const response = await http.post(
    `routes/${id}/unloading-places`,
    unloadingPlace,
  );
  return response;
}

async function deleteUnloadingPlace(routeId, unloadingPlaceId) {
  await http.delete(`routes/${routeId}/unloading-places/${unloadingPlaceId}`);
  return true;
}

async function updateUnloadingPlaceRouteItem(id, itemId, unloadingPlaceId) {
  const response = await http.patch(`routes/${id}/route-items/${itemId}/unloading-place`, { value: unloadingPlaceId });
  return response;
}

async function updateInCar(id, itemId) {
  const response = await http.patch(`routes/${id}/route-items/${itemId}/in-car`);
  return response;
}

async function changeItemPosition(id, itemId, position) {
  const response = await http.patch(`routes/${id}/route-items/${itemId}/position`, { value: position });
  return response;
}

async function deleteItem(id, itemId) {
  await http.delete(`routes/${id}/route-items/${itemId}`);
  return true;
}

async function changeDeliveryToUnloadingPlaceFactDate(id, itemId, date) {
  await http.patch(`routes/${id}/route-items/${itemId}/delivery-to-unloading-place-fact`, {
    value: date,
  });
}

async function changeUnloaded(routeId, itemId, date) {
  await http.patch(`routes/${routeId}/route-items/${itemId}/unloaded`, {
    value: date,
  });
}

async function addRouteItems(routeId, items) {
  const response = await http.post(`routes/${routeId}/route-items`, items);
  return response.data;
}

async function updateVolume(routeId, itemId, volume) {
  await http.patch(`routes/${routeId}/route-items/${itemId}/volume`, {
    value: volume,
  });
}

async function updateWeight(routeId, itemId, weight) {
  await http.patch(`routes/${routeId}/route-items/${itemId}/weight`, {
    value: weight,
  });
}

async function updateCargoPlaces(routeId, itemId, cargoPlaces) {
  await http.patch(`routes/${routeId}/route-items/${itemId}/cargo-places`, {
    value: cargoPlaces,
  });
}

async function getStatesHistory(id) {
  const response = await http.get(`routes/${id}/states-history`);
  return response.data.map(h => {
    return {
      id: h.Id,
      createdAt: h.CreatedAt,
      author: h.Author,
      state: h.State.Title,
    };
  });
}

async function updateUnloadingPlace(id, unloadingPlaceId, unloadingPlace) {
  const response = await http.put(`routes/${id}/unloading-places/${unloadingPlaceId}`, unloadingPlace);
  return response;
}

async function getNotes(id) {
  const response = await http.get(`/routes/${id}/notes`);
  return response.data.map(n => {
    return {
      id: n.Id,
      text: n.Text,
      date: n.ChangedAt,
      author: n.Author,
    };
  });
}

async function createRouteNote(id, note) {
  const response = await http.post(`/routes/${id}/notes`, {
    text: note,
  });
  return response;
}

async function updateRouteNote(id, noteId, note) {
  const response = await http.put(`/routes/${id}/notes/${noteId}`, {
    text: note,
  });
  return response;
}

async function deleteRouteNote(id, noteId) {
  const response = await http.delete(`/routes/${id}/notes/${noteId}`);
  return response;
}

async function getPackages(id) {
  const response = await http.get(`routes/${id}/packages`);
  return response.data.map(i => {
    return {
      oversize: i.Oversize,
      type: i.Type,
      length: i.Length || 0,
      width: i.Width || 0,
      height: i.Height || 0,
      quantity: i.Quantity || 0,
      volume: i.Volume || 0,
      items: i.Items.map(i => {
        return {
          id: i.Id,
          title: i.Title,
        };
      }),
    };
  });
}

async function getPackagesInfo(id, routeItemId) {
  const response = await http.get(`routes/${id}/route-items/${routeItemId}/packages`);
  return {
    client: response.data.Client ? { id: response.data.Client.Id, title: response.data.Client.Title } : null,
    clientAlias: response.data.ClientAlias,
    factory: response.data.Factory ? { id: response.data.Factory.Id, title: response.data.Factory.Title } : null,
    productDescription: response.data.ProductDescription,
    weight: response.data.Weight,
    items: response.data.Items.map(i => {
      return {
        id: i.Id,
        packageType: i.PackageType ? {
          id: i.PackageType.Id,
          title: i.PackageType.Title,
        } : null,
        length: i.Length,
        width: i.Width,
        height: i.Height,
        quantity: i.Quantity,
      };
    }),
  };
}

async function changePackagesInfo(id, routeItemId, packages) {
  const response = await http.put(`routes/${id}/route-items/${routeItemId}/packages`, packages);
  return response;
}

async function changeDeliveryToUnloadingPlacePlanDate(id, itemId, date) {
  await http.patch(`routes/${id}/items/${itemId}/delivery-to-unloading-plan`, {
    value: date,
  });
}

async function changeLoadingLogist(id, itemId, loadingLogist) {
  await http.patch(`routes/${id}/items/${itemId}/loading-logist`, {
    value: loadingLogist,
  });
}

async function getShippingsPackages(id) {
  const response = await http.get(`routes/${id}/shipping-packages`);
  return response.data.map(item => {
    return {
      packages: item.Packages.map(i => {
        return {
          packageId: i.PackageId,
          oversize: i.Oversize,
          type: i.Type,
          length: i.Length,
          width: i.Width,
          height: i.Height,
          quantity: i.Quantity,
          volume: i.Volume,
        };
      }),
      routeItemId: item.RouteItemId,
      shippingNumber: item.ShippingNumber,
    };
  });
}

async function allowEditingRouteItem(id, itemId) {
  await http.patch(`routes/${id}/route-items/${itemId}/allow-editing`);
}

export {
  getCustomsManagerSelect,
  fetchAllCustomsManagers,
  searchCustomManager,
  getLogistSelect,
  fetchAllLogists,
  searchLogist,
  getShippings,
  getRoute,
  getRouteItems,
  changeState,
  deleteRoute,
  saveCustomsRegistrationDate,
  saveArriveToWarehouseDate,
  changeRouteInfo,
  saveRoutePrefix,
  saveReadyForShipmentDate,
  getFactoryLoadingPlace,
  updateLoadingAddress,
  getFactoryLoadingPlaceReference,
  getLoadingPlaceReference,
  searchLoadingPlace,
  createUnloadingPlace,
  deleteUnloadingPlace,
  updateUnloadingPlaceRouteItem,
  updateInCar,
  changeItemPosition,
  deleteItem,
  changeDeliveryToUnloadingPlaceFactDate,
  changeUnloaded,
  addRouteItems,
  updateVolume,
  updateWeight,
  updateCargoPlaces,
  getStatesHistory,
  updateUnloadingPlace,
  getNotes,
  createRouteNote,
  updateRouteNote,
  deleteRouteNote,
  getPackages,
  getPackagesInfo,
  changePackagesInfo,
  changeDeliveryToUnloadingPlacePlanDate,
  changeFactoryClosingDate,
  changeLoadingLogist,
  getShippingsPackages,
  allowEditingRouteItem,
};